import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Plus, Pencil, Trash2 } from "lucide-react";
import SupplierPicker from "@/components/SupplierPicker";

const FIELDS = [["sole_code", "Taban Kodu *", "Örn: TB-55"], ["sole_color", "Taban Rengi *", "Örn: Kahve"], ["note", "Not", ""]];

const dialogTitle = (editingId, lockCode, code) =>
  editingId ? "Taban Kartını Düzenle" : lockCode ? `${code} · Renk Ekle` : "Yeni Taban Kartı";

const submitLabel = (submitting, editingId) => (submitting ? "Kaydediliyor..." : editingId ? "Kaydet" : "Kartı Oluştur");

export const SoleCardForm = ({ form, setForm, editingId, lockCode, suppliers, submitting, onSubmit }) => (
  <DialogContent className="bg-[#FFFBF4] border-[#DCCFB8] text-[#2B2118] max-w-xl" data-testid="sole-card-dialog">
    <DialogHeader>
      <DialogTitle className="font-display text-2xl uppercase tracking-tight">{dialogTitle(editingId, lockCode, form.sole_code)}</DialogTitle>
    </DialogHeader>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {FIELDS.map(([f, label, ph]) => (
        <div key={f}>
          <Label className="text-xs text-[#6B5B4A]">{label}</Label>
          <Input data-testid={`sole-card-${f}`} value={form[f]} placeholder={ph}
            disabled={lockCode && f === "sole_code"}
            onChange={(e) => setForm({ ...form, [f]: e.target.value })}
            className="mt-1 h-11 bg-[#EFE6D6] border-[#DCCFB8]" />
        </div>
      ))}
    </div>
    <div>
      <Label className="text-xs text-[#6B5B4A] mb-1 block">Taban Firması (Tabancı) *</Label>
      <SupplierPicker value={suppliers.find((x) => x.name === form.supplier)?.id || ""} testId="sole-card-supplier"
        onChange={(id, sup) => setForm((f) => ({ ...f, supplier: sup?.name || "" }))} />
    </div>
    {editingId && (
      <p className="text-[11px] text-[#8C7B68]">Kod veya renk değişirse bu tabanı kullanan stok kartları, taban stoğu ve geçmiş kayıtlar da güncellenir.</p>
    )}
    <DialogFooter>
      <Button onClick={onSubmit} disabled={submitting} data-testid="sole-card-submit-btn"
        className="bg-[#D97706] hover:bg-[#B45309] text-white font-display uppercase tracking-wide h-11 px-6">
        {submitLabel(submitting, editingId)}
      </Button>
    </DialogFooter>
  </DialogContent>
);

const SoleColorRow = ({ c, models, onEdit, onRemove }) => (
  <div className="flex items-center justify-between py-2" data-testid={`sole-card-row-${c.id}`}>
    <div className="min-w-0">
      <p className="font-medium">{c.sole_color || "Renksiz"}</p>
      <p className="text-[11px] font-mono text-[#8C7B68]">
        <span className={c.supplier ? "" : "text-[#EF4444]"}>{c.supplier || "Tabancı tanımsız"}</span> · Modeller: {models.join(", ") || "—"}
      </p>
    </div>
    <div className="whitespace-nowrap">
      <button onClick={() => onEdit(c)} data-testid={`sole-card-edit-${c.id}`} className="text-[#8C7B68] hover:text-[#B45309] mr-3"><Pencil className="w-4 h-4" /></button>
      <button onClick={() => onRemove(c.id)} data-testid={`sole-card-delete-${c.id}`} className="text-[#8C7B68] hover:text-[#EF4444]"><Trash2 className="w-4 h-4" /></button>
    </div>
  </div>
);

export const SoleCodeGroup = ({ code, colors, modelsOf, onAddColor, onEdit, onRemove }) => (
  <div className="rounded-md border border-[#E8DDCA] bg-[#F5EFE4]/50 p-3" data-testid={`sole-code-group-${code}`}>
    <div className="flex items-center justify-between mb-2">
      <span className="min-w-0">
        <span className="font-display text-xl font-extrabold uppercase text-[#B45309]">{code}</span>
        <span className="block text-[11px] font-mono text-[#6B5B4A]" data-testid={`sole-code-supplier-${code}`}>
          Tabancı: {[...new Set(colors.map((c) => c.supplier).filter(Boolean))].join(", ") || "tanımsız"}
        </span>
      </span>
      <button onClick={() => onAddColor(code)} data-testid={`sole-code-add-color-${code}`}
        className="text-xs font-display uppercase tracking-wide text-[#B45309] hover:underline flex items-center gap-1">
        <Plus className="w-3.5 h-3.5" /> Renk Ekle
      </button>
    </div>
    <div className="divide-y divide-[#E8DDCA]">
      {colors.map((c) => <SoleColorRow key={c.id} c={c} models={modelsOf(c)} onEdit={onEdit} onRemove={onRemove} />)}
    </div>
  </div>
);
